import FixtureCardSlotted from './fixtureCardSlotted.component';

export * from './fixtureCardSlotted.types';
export default FixtureCardSlotted;
